import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import { CategoryValidations } from '../../../models';
import styles from './AddCategoryForm.styles';

import AddForm from '../addform/AddForm';
import Button from '../../inputs/button/Button';
import Icon from '../../common/icon/Icon';
import FormActions from '../formactions/FormActions';
import FormField from '../formfield/FormField';

export class AddCategoryForm extends Component {
  render() {
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <div className={css(styles.idField)}>
          <Field
            name="name"
            label={I18n.t('models.category.name')}
            type="text"
            placeholder={I18n.t('models.category.name')}
            component={FormField}
            maxLength="24"
            validate={CategoryValidations.category}
          />
          {this.props.isEditing && (
            <Icon
              value="trash"
              styles={styles.deleteIcon}
              onClick={this.props.onDelete}
            />
          )}
        </div>
        <FormActions>
          <Button>{I18n.t('add.save')}</Button>
          <Button
            styles={styles.flatButton}
            type="button"
            onClick={this.props.onCancel}
          >
            {I18n.t('cancel')}
          </Button>
        </FormActions>
      </AddForm>
    );
  }
}

export default reduxForm({
  form: 'addCategory'
})(AddCategoryForm);



// WEBPACK FOOTER //
// ./src/components/forms/addcategoryform/AddCategoryForm.js